module.exports = __webpack_public_path__ + "static/media/press-kit.1f4f5508.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/media/press-kit.jpeg
// module id = 295
// module chunks = 0